"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetCapturedAuthorizationResponse = exports.takeCapturedAuthorizationResponseUrl = exports.captureAuthorizationResponse = void 0;
const authorizationResponseParams = [
    "code",
    "state",
    "session_state",
    "iss",
    "error",
    "error_description",
    "error_uri"
];
let capturedUrl;
const usesCodeFlow = (target) => {
    let config = target.externalConfig;
    return !!config && !!config.openidServerUrl && !config.openidUseImplicitFlow;
};
const isAuthorizationResponse = (search) => {
    let params = new URLSearchParams(search);
    return params.has("state") && (params.has("code") || params.has("error"));
};
const searchWithoutAuthorizationParams = (search) => {
    let params = new URLSearchParams(search);
    authorizationResponseParams.forEach(param => params.delete(param));
    return params.toString();
};
const captureAuthorizationResponse = (target) => {
    if (!usesCodeFlow(target))
        return;
    if (!isAuthorizationResponse(target.location.search))
        return;
    capturedUrl = target.location.href;
    let remainingSearch = searchWithoutAuthorizationParams(target.location.search);
    let query = remainingSearch ? `?${remainingSearch}` : "";
    target.history.replaceState({}, "", `${target.location.pathname}${query}${target.location.hash}`);
};
exports.captureAuthorizationResponse = captureAuthorizationResponse;
const takeCapturedAuthorizationResponseUrl = () => {
    let url = capturedUrl;
    capturedUrl = undefined;
    return url;
};
exports.takeCapturedAuthorizationResponseUrl = takeCapturedAuthorizationResponseUrl;
const resetCapturedAuthorizationResponse = () => {
    capturedUrl = undefined;
};
exports.resetCapturedAuthorizationResponse = resetCapturedAuthorizationResponse;
